import { graphql } from 'gql';

export const uerWorkOrderActKC2MtrForInflationDistributionGql = graphql(`
    query uerWorkOrderActKC2MtrForInflationDistribution(
        $skip: Int
        $take: Int
        $actKC2Id: Long!
        $chapter: ChapterEnum!
        $workOrderObjectId: Long!
        $where: WorkOrderMtrInflationDataFilterInput
    ) {
        uerWorkOrderActKC2MtrForInflationDistribution(
            skip: $skip
            take: $take
            actKC2Id: $actKC2Id
            chapter: $chapter
            workOrderObjectId: $workOrderObjectId
            where: $where
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                code
                id
                inflationSeasonId
                mtrRowId
                name
                parentId
                seasonId
                status
                type
                uerCode
                uerCodeId
                uerId
            }
        }
    }
`);

export const uerUpdateWorkOrderActKC2MTRForInflationDistributionGql = graphql(`
    mutation uerUpdateWorkOrderActKC2MTRForInflationDistribution(
        $actKC2Id: Long!
        $useInflationMTR: Boolean!
        $actKC2MtrItems: [ActKC2MtrItemInput!]!
    ) {
        uerUpdateWorkOrderActKC2MTRForInflationDistribution(
            actKC2Id: $actKC2Id
            useInflationMTR: $useInflationMTR
            actKC2MtrItems: $actKC2MtrItems
        ) {
            actionRequired
            buttonText
            code
            hideValidation
            hasValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);
